import { groq } from '@nuxtjs/sanity';

const getVideoDatasFromRef = (ref) => groq`*[_id=="${ref}"][0]{
  ...
}`;

export default getVideoDatasFromRef;
